import { loaderSlice } from './slices';
import { createAction } from '@reduxjs/toolkit';

export const { setDashboardLoader, setProfileLoader, setDepositsLoader } = loaderSlice.actions;

export const countdownDone = createAction('loaders/countdown-done');
